import { Flex, Button, Text } from '@pancakeswap/uikit'
import QuestionHelper from 'components/QuestionHelper'
import { formatPrice } from 'config/constants/exchange'
import { useTranslation } from 'contexts/Localization'
import { useEffect } from 'react'
import { useDynamicGasTiers, useGasPriceManager } from 'state/user/hooks'


const GasSettings = () => {
  const { t } = useTranslation()
  const [gasPrice, setGasPrice] = useGasPriceManager()
  const tiers = useDynamicGasTiers()

  useEffect(() => {
    console.log(gasPrice)
    console.log(tiers?.medium)
    if (tiers?.medium && !gasPrice) {
      setGasPrice(tiers.medium);
    }
  }, [tiers, gasPrice, setGasPrice]);

  return (
    <Flex flexDirection="column">
      <Flex mb="12px" alignItems="center">
        <Text>{t('Transaction Speed (GWEI)')}</Text>
        <QuestionHelper
          text={t('Adjusts the gas price (transaction fee). Higher GWEI = faster confirmation = higher fees')}
          placement="top-start"
          ml="4px"
        />
      </Flex>

      <Flex flexWrap="wrap">
        {tiers &&
          Object.entries(tiers).map(([label, value]) => {

            const gwei = Number(value) / 1e9
            return (
              <Button
                mt="2px"
                mr="2px"
                scale="sm"
                key={label}
                onClick={() => setGasPrice(value)}
                variant={gasPrice === value ? 'primary' : 'tertiary'}
              >
                {label.toUpperCase()} ({formatPrice(gwei, 4)} GWEI)
              </Button>
            )
          })}
      </Flex>
    </Flex>
  )
}

export default GasSettings
